<style lang="scss" scoped>
.comp-picker-link {
  .btn-item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;

    .btn-linkpath {
      flex: 1;
    }

    .input-m {
      margin-left: 3px;
    }
  }

  .linktype-radio {
    margin-top: 10px;
    margin-bottom: 6px;

    .el-radio {
      margin-right: 8px;

      &:last-child {
        margin-right: 0;
      }
    }

    .el-radio__label {
      padding-left: 2px;
      font-size: 13px;
    }
  }

  .btn-linkpath {
    display: flex;
    align-items: center;
    min-width: 160px;
    justify-content: space-between;

    .text {
      color: var(--themeColor);
      background-color: #fff;
      font-size: 12px;
      height: 32px;
      line-height: 32px;
      border-radius: 3px;
      max-width: 160px;
      padding: 0 5px;
      @include text-overflow();
      width: 160px;
    }
  }

  input::-webkit-input-placeholder {
    font-size: 12px;
  }

  .el-input__inner {
    padding: 0 8px;
  }

  .h5-link {
    margin-top: 10px;
    display: block;
  }

  .video-list {
    display: flex;
  }

  .register-channel {
    padding-top: 15px;

    .register-channel-position {
      padding-top: 15px;
      display: flex;
      align-items: center;
    }

    // &-label {
    //   padding-right: 10px;
    //   font-size: 12px;
    // }

    .el-button {
      margin-left: 10px;
      width: auto !important;
    }

    .icon-warning {
      margin: 0px !important;
    }
  }

}
</style>
<style lang="scss">
.register-channel-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.register-channel-label {
  padding-right: 10px;
  font-size: 12px;
}

.register-channel-item {
  display: flex;
  align-items: center;
  padding-bottom: 10px;
}

.register-channel-popover-button {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.register-channel-popover {
  display: flex;
  align-items: center;

  .el-input {
    width: 200px;
  }

  .el-button {
    margin-left: 10px;
  }
}

.register_drawer {
  margin-bottom: 6px;
}
</style>
<template>
  <div class="comp-picker-link">
    <div class="btn-item">
      <div class="btn-linkpath">
        <div class="text" @click="onPickerPath"> {{ getLabelName() }} </div>
        <el-button size='mini' type='text' @click='handleClear'>清除</el-button>
      </div>

      <el-select class="input-m" v-model="localValue.rule_id" placeholder="请选择" filterable remote clearable
        v-if="localValue && localValue.id == 'drawer-shop'" size="small" @change="handleRuleIdChange">
        <el-option v-for="item in list" :key="item.rule_id" :label="item.rule_title" :value="item.rule_id">
        </el-option>
      </el-select>
      <el-input v-model="localValue.liveId" placeholder="请填写抖音直播ID" v-if="localValue && localValue.id == 'douyinLive'"
        size="small" class="input-m" />
      <el-input v-model="localValue.imId" placeholder="请填写抖音客服ID" v-if="localValue && localValue.id == 'douyinIm'"
        size="small" class="input-m" />
      <el-input v-model="localValue.byte_mini_shop_id" placeholder="请填写抖音小店ID"
        v-if="localValue && localValue.id == 'douyinStore'" size="small" class="input-m" />
    </div>
    <!-- <div v-if="localValue.id === 'ACSPurchasePopup'">
      <span>选择acs商品</span><span style="color: red;">*</span>：
      <el-select class="input-m" v-model="localValue.acs_item_id" placeholder="请选择" filterable remote size="small">
        <el-option v-for="item in skuItemsList" :key="item.item_id" :label="item.item_name" :value="item.item_id">
          <span style="float: left">{{ item.item_name }}</span>
          <span style="float: right; color: #8492a6; font-size: 13px;margin-left: 20px;">{{ item.item_bn }}</span>
        </el-option>
      </el-select>
    </div> -->
    <div v-if="localValue.id === 'CopyLink'">
      <el-input v-model="localValue.CopyUrl" placeholder="请输入链接" class="h5-link" size="small" type="text" />
      <el-input v-model="localValue.CopyTitle" placeholder="请输入复制文案" class="h5-link" size="small" type="text" />
    </div>
    <div v-if="localValue.id === 'thirdpage'">
      <el-input v-model="localValue.linkTitle" placeholder="请输入跳转路径" class="h5-link" size="small" type="text" />
      <el-input v-model="localValue.linkAppid" placeholder="请输入对应小程序APPID" class="h5-link" size="small" type="text" />
      <div style="display: flex; align-items: center; margin-top: 10px;justify-content: space-between;">
        <span>传递用户身份:</span>
        <el-switch v-model="localValue.passUserIdentity"></el-switch>
      </div>
      <div v-if="isShowLinkprogram">
        <span>是否半屏跳转:</span>
        <el-radio-group v-model="localValue.linkProgram" style="display: inline-block;padding-left: 10px;">
          <el-radio label="1">否</el-radio>
          <el-radio label="2">是</el-radio>
        </el-radio-group>
      </div>
    </div>
    <div v-if="localValue.id === 'videopage' && isShowVideo">
      <el-radio-group v-model="localValue.autoplay" class="linktype-radio">
        <el-radio :label="true"> 开启自动播放 </el-radio>
        <el-radio :label="false"> 关闭自动播放 </el-radio>
      </el-radio-group>
      <div class="video-list">
        <SpImagePicker v-model="localValue.video_cover" size="small" class="video-link" text="封面" />
        <SpVideoPicker type="object" v-model='localValue.video' size='small' class="video-link" />
      </div>
    </div>
    <div class="register-channel"
      v-if="localValue.id === 'register' || localValue.id === 'registerDrawer' || localValue.id === 'registerActivity' || localValue.linkPage === 'ordertogift'">
      <div class="register-channel-item"
        v-if="localValue.id === 'register' || localValue.id === 'registerDrawer' || localValue.id === 'registerActivity'">
        <span class="register-channel-label">注册渠道</span>
        <el-select v-model="localValue.channel" placeholder="请选择" class="register-channel-select" size="small"
          filterable remote reserve-keyword :remote-method="getChannelList" @change="changeChannel">
          <!-- clearable -->
          <el-option v-for="item in options" :key="item.value" :value="item.value" :label='item.label'
            class="register-channel-option">
            <!-- <span>{{ item.label }}</span> -->
            <!-- <i class="el-icon-delete" @click="delChannel(item.value)"></i> -->
          </el-option>
        </el-select>
        <el-popover placement="bottom" width="320" trigger="click" ref="popover">
          <div class="register-channel-popover-content">
            <div class="register-channel-popover">
              <span class="register-channel-label">注册渠道名称</span>
              <el-input v-model="channelName" placeholder="请输入渠道名称" size="small" />
            </div>
            <div class="register-channel-popover-button">
              <el-button size="small" @click="cancelChannel">取消</el-button>
              <el-button type="primary" size="small" @click="addChannel">确定</el-button>
            </div>
          </div>
          <el-button type="text" size="small" slot="reference">新增渠道
          </el-button>
        </el-popover>
        <el-tooltip class="item" effect="light" placement="bottom">
          <div slot="content">
            注册渠道用于记录会员通过哪个渠道进入小程序完成注册,</br>并且可以用于设置页面内容(热区图)时可针对通过指定渠</br>道注册会员可见
          </div>
          <el-button class="icon-warning" type="text" size="small" icon="el-icon-warning" />
        </el-tooltip>
      </div>
      <div v-if="localValue.id === 'registerDrawer'">
        <div class="register-channel-popover register_drawer">
          <span class="register-channel-label">背景图</span>
          <SpImagePicker v-model="localValue.background_img" size="small" class="video-link" text="背景" />
        </div>
        <div class="register-channel-item register_drawer">
          <span class="register-channel-label">会员按钮样式</span>
          <el-color-picker v-model="localValue.textColor" size='small' />
          <el-input-number controls-position="right" v-model="localValue.textSize" class="register-channel-select"
            size="small"></el-input-number>
        </div>
      </div>
      <div class="register-channel-item">
        <span class="register-channel-label">协议底部位置</span>
        <el-input-number controls-position="right" v-model="localValue.bottom" class="register-channel-select"
          size="small"></el-input-number>
      </div>
      <div v-if="localValue.id === 'registerActivity'" class="register-channel-item">
        <span class="register-channel-label">活动名称</span>
        <el-input v-model="localValue.exchangeActivityTitle" placeholder="请输入活动名称" size="small" />
      </div>
      <div class="register-channel-item" v-if="localValue.id === 'registerDrawer' || localValue.id === 'register'">
        <span class="register-channel-label">会员注册跳转</span>
        <el-radio-group v-model="localValue.registerSuccessPath" @input="changeRegisterSuccessPath">
          <el-radio label="member_center">会员中心</el-radio>
          <el-radio label="blessing">欢迎语</el-radio>
        </el-radio-group>
      </div>
    </div>

    <div class="register-channel"
      v-if="((localValue.id === 'register' || localValue.id === 'registerDrawer') && localValue.registerSuccessPath == 'blessing') || localValue.id === 'ciaimBenefits'">
      <div class="register-channel-item">
        <span class="register-channel-label">关联祝福语</span>
        <div class="btn-linkpath">
          <div class="text" @click="onWelcomeInfo">{{ localValue.blessing_title }}</div>
          <el-button size='mini' type='text' @click='handleClearWelcomeInfo'>清除</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { cloneDeep, isUndefined } from 'lodash'
import { mapGetters } from "vuex";
import { isObject } from '@/utils'
import { getShowRuleList } from '@/api/template'
import { LINK_PATH } from '@/consts'
import api from '@/api'
import { useDialog } from '@shopex/finder'
export default {
  name: 'CompHotPicker',
  props: {
    value: {
      type: [Object, Array],
      default: () => { }
    },
    isShowH5Link: {
      // 不展示自定义链接label true：展示
      type: Boolean,
      default: true
    },
    isShowLinkprogram: {
      type: Boolean,
      default: false
    },
    isShowVideo: {
      type: Boolean,
      default: true
    },
    wgtType: {
      type: String,
      default: ''
    },
    platform: {
      type: String,
      default: ''
    },
    hiddenbtntype: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      localValue: {
        linkPage: '',
        id: '',
        title: '',
        ctoken: '',
        linkType: 0,
        linkUrl: '',
        video_cover: '',
        CopyUrl: "",
        CopyTitle: "",
        autoplay: false,
        bottom: 0,
        channel: 0,
        channelName: '常规注册渠道',
        background_img: '',
        textColor: '#ffffff',
        textSize: 12,
        blessing_id: '',
        blessing_title: '',
        exchangeActivityTitle: '',
        // 会员注册成功跳转路径
        registerSuccessPath: 'member_center',
        passUserIdentity: false,
      },
      list: [],
      options: [],
      channelName: '',
      skuItemsList: []
    }
  },
  watch: {
    localValue: {
      deep: true,
      handler: function (nVal, oVal) {
        this.$emit('input', nVal)
        this.$emit('change', nVal)
      }
    }
  },

  computed: {
    ...mapGetters([
      'template_name',
      'wxapp_id'
    ])
  },

  created() {
    const localValue = Object.assign(this.localValue, this.value)
    const { video } = localValue
    localValue.video = isObject(video) ? video : {}
    this.localValue = cloneDeep(localValue)
    if (localValue.id == 'drawer-shop') {
      this.getList()
    }
    if (localValue.id == 'register' || localValue.id == 'registerDrawer' || localValue.id == 'registerActivity') {
      this.getChannelList()
    }
    // if (localValue.id == 'ACSPurchasePopup') {
    //   this.getSkuItemsList()
    // }
  },
  methods: {
    async onPickerPath() {
      const { template_douyin = 0 } = this.$route.query
      const { linkPage, id } = this.localValue
      const res = await this.$picker.path({
        data: id,
        tab: linkPage,
        multiple: false,
        wxapp_id: this.wxapp_id,
        template_name: this.template_name,
        isDouyin: template_douyin == 1 || this.platform == 'byte_mini',
        wgtType: this.wgtType,
        isHotWords: false,
        hiddenbtntype: this.hiddenbtntype
      })

      this.localValue = {
        ...res,
        linkType: 0,
        linkUrl: '',
        video_cover: '',
        CopyUrl: "",
        CopyTitle: "",
        autoplay: false,
        video: {},
        background_img: '',
        textColor: '#ffffff',
        textSize: 12,
        blessing_id: '',
        blessing_title: '',
        exchangeActivityTitle: '',
        registerSuccessPath: 'member_center',
        passUserIdentity: false,
      }
      if (res.id == "drawer-shop") {
        this.getList()
      } else if (res.id == 'register' || res.id == 'registerDrawer' || res.id == 'registerActivity') {
        await this.getChannelList()
        this.$set(this.localValue, 'channel', this.options[0].value)
      } else if (res.id == 'ACSPurchasePopup') {
        // this.getSkuItemsList()
      } else {
        this.$set(this.localValue, 'rule_id', '')
      }
    },
    handleClear() {
      this.localValue = {
        linkPage: '',
        id: '',
        title: '',
        ctoken: '',
        linkType: 0,
        linkUrl: '',
        video_cover: '',
        CopyUrl: "",
        CopyTitle: "",
        autoplay: false,
        bottom: 0,
        channel: 0,
        channelName: '常规注册渠道',
        acs_item_id: '',
        background_img: '',
        textColor: '#ffffff',
        textSize: 12,
        blessing_id: '',
        blessing_title: '',
        exchangeActivityTitle: '',
        registerSuccessPath: 'member_center',
        passUserIdentity: false,
      }
    },
    getLabelName() {
      const { linkPage, title, id } = this.localValue
      if (linkPage) {
        return `${LINK_PATH[linkPage]}：${id ? '[' + id + ']' : ''} ${title}`
      } else {
        return '选择路径'
      }
    },
    changeChannel(value) {
      const name = this.options.find(item => item.value == value)?.label
      this.$set(this.localValue, 'channelName', name)
    },
    async getList() {
      const { template_douyin = 0 } = this.$route.query
      const res = await getShowRuleList({
        page: 1,
        page_size: -1,
        platform: template_douyin == 1 ? 'byte_mini' : 'wxapp',
      })
      this.list = [{ rule_id: '0', rule_title: '全部门店' }, ...res.data.data.list]
    },
    async getChannelList(name = '') {
      const { data } = await api.member.getMemberChannelList({ channel_name: name, channel_id: '' })
      let list = data?.data?.list || []
      this.options = list.map(item => ({ value: item.channel_id, label: item.channel_name }))

    },

    async getSkuItemsList(name = '') {
      const params = {
        item_type: 'normal',
        item_tier: ['acs'],
        // special_type: ['normal'],
        page: 1,
        pageSize: 10000
      }
      const { data } = await api.goods.getItemsList(params)
      this.skuItemsList = data?.data?.list || []
    },

    async addChannel() {
      if (!this.channelName) {
        this.$message.warning('请输入渠道名称')
        return
      }
      await api.member.createMemberChannel({ channel_name: this.channelName })
      this.$message.success('添加成功')
      this.channelName = ''
      this.$refs.popover.doClose();
      this.getChannelList()
    },
    delChannel(value) {
      this.options = this.options.filter(item => item.value != value)
    },
    cancelChannel() {
      this.channelName = ''
      this.$refs.popover.doClose();
    },
    handleRuleIdChange(id) {
      let item = this.list.find(item => item.rule_id == id)
      this.localValue.distributor_header_image = item.distributor_header_image || ''
    },
    onWelcomeInfo() {
      useDialog(null, {
        title: `添加欢迎语`,
        width: '40%',
        component: () => import('./comp-welcome.vue'),
        actions: [{ label: '取消', key: 'close', size: 'default' },
                  { label: '确认', key: 'save', type: 'primary', size: 'default' }],
      }).then((arg) => {
        if (arg.id) {
          this.$set(this.localValue, 'blessing_id', arg.id)
          this.$set(this.localValue, 'blessing_title', arg.template_title)
        }
      })
    },
    handleClearWelcomeInfo() {
      this.$set(this.localValue, 'blessing_id', '')
      this.$set(this.localValue, 'blessing_title', '')
    },
    changeRegisterSuccessPath(v) {
      if (v == 'member_center') {
        this.handleClearWelcomeInfo()
      }
    }
  },
}
</script>
